$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    const $navList = $('.js-nav-list');
    const $sections = $('[data-nav-marker]');

    function updateActiveNav() {
        let currentSectionId = null;

        // Find the section in view
        $sections.each(function () {
            const $section = $(this);
            const sectionTop = $section.offset().top;
            const sectionHeight = $section.outerHeight();
            const scrollPos = $(window).scrollTop();
            if (scrollPos >= sectionTop - 161 && scrollPos < sectionTop + sectionHeight - 160) {
                currentSectionId = $(this).attr("data-nav-marker");
                return false; // Break the loop
            }
        });

        // Remove active class from all nav items
        $navList.find('li').removeClass('active');

        // Add active class to the corresponding nav item
        if (currentSectionId) {
            $navList.find(`li a[href*="${currentSectionId}"]`).parent('li').addClass('active');
        }
    }

    // Run on scroll
    $(window).on('scroll', updateActiveNav);

    // Run once on page load
    updateActiveNav();

    $navList.find("li a").click(function () {
        $(".js-navbutton").removeClass("active");
        $(".js-navmobile").removeClass("active");
    })

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * fixed Header
    // *
    // *
    const $header = $('.js-header-fixed');
    const $heroSection = $('.js-hero');
    var heroSectionTop = 0;
    var heroSectionHeight = 0;
    if ($heroSection.length > 0) {
        heroSectionTop = $heroSection.offset().top;
        heroSectionHeight = $heroSection.outerHeight();
        $(window).on('scroll', updateHeaderClass);
        updateHeaderClass(); // Run once on page load
    }

    function updateHeaderClass() {
        const scrollPos = $(window).scrollTop();

        if (scrollPos > heroSectionTop + heroSectionHeight - 100) {
            $header.addClass('sticky'); // Replace 'scrolled' with your desired class name
        } else {
            $header.removeClass('sticky');
        }
    }




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(".js-navbutton").toggleClass("active");
        $(".js-navmobile").toggleClass("active");
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * productTeaserSlider
    // *
    // *
    var $productTeaserSlider = $(".js-productteaser-slider");

    if ($productTeaserSlider.length) {
        $productTeaserSlider.each(function () {
            $(this).find(".js-productteaser-slider-track").slick({
                fade: true,
                infinite: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 4000,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: false,
                prevArrow: $(this).find(".js-productteaser-slider-prev"),
                nextArrow: $(this).find(".js-productteaser-slider-next"),
            });
        });
    }
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * instagramSlider
    // *
    // *
    var $instagramSlider = $(".js-instagram-slider");

    if ($instagramSlider.length) {
        $instagramSlider.each(function () {
            $(this).find(".js-instagram-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 3000,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: false,
                prevArrow: false,
                nextArrow: false,
                slidesToShow: 2.4,
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 3,
                            centerMode: true,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.01,
                            centerMode: true,
                        }
                    }
                ]
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * imageBoxSlider
    // *
    // *

    // Select the shuffle list and its items
    const $shuffleList = $('.js-shuffle-list');
    const $shuffleItems = $('.js-shuffle-item');

    // Convert the items to an array for shuffling
    if ($shuffleItems.length > 0) {


        const itemsArray = $shuffleItems.get();

        // Shuffle the array
        for (let i = itemsArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            let temp = itemsArray[i];
            itemsArray[i] = itemsArray[j];
            itemsArray[j] = temp;
        }
        $shuffleList.append(itemsArray);
    }

    var $totalElement = $(this).find(".js-imagebox-slider-total");

    var totalSlides = $totalElement.parents(".js-imagebox-slider").find(".js-imagebox-slide").length;

    var formattedTotal = totalSlides < 10 ? "0" + totalSlides : totalSlides;

    $totalElement.text(formattedTotal);

    var $imageBoxSlider = $(".js-imagebox-slider");

    if ($imageBoxSlider.length) {
        $imageBoxSlider.each(function () {
            $(this).find(".js-imagebox-slider-track").slick({
                fade: true,
                infinite: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 4000,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: false,
                adaptiveHeight: true,
                prevArrow: $(this).find(".js-imagebox-slider-prev"),
                nextArrow: $(this).find(".js-imagebox-slider-next"),
            });
            $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                setTimeout(() => {
                    var i = (nextSlide + 1);
                    $(this).find(".js-imagebox-slider-count").text(`0${i}`);
                }, 400);
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * imageTicker
    // *
    // *
    var $imageTickerSlider = $(".js-imageticker-slider");

    if ($imageTickerSlider.length) {
        $imageTickerSlider.each(function () {
            $(this).find(".js-imageticker-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 4000,
                cssEase: 'linear',
                waitForAnimate: true,
                variableWidth: false,
                dots: true,
                appendDots: false,
                prevArrow: false,
                nextArrow: false,
                slidesToShow: 3.5,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this).parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        setTimeout(() => {
            $(this)[0].scrollIntoView({ behavior: 'smooth' });
        }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split('#')[1];
        if (hash && $("#" + hash).hasClass("js-accordion-button") && $("#" + hash).siblings(".js-accordion-content").attr("aria-expanded") !== "true") {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    var $dialog = $(".js-dialog"),
        dialogState = sessionStorage.getItem('dialogState');

    $(".js-close-dialog").click(function () {
        $dialog.addClass("close");
        sessionStorage.setItem('dialogState', true);
        $(this).parents(".js-dialog").get(0).close();
        $("body").removeClass("freeze");
    });

    // backdrop click
    $(".js-dialog").click(function (e) {
        if (e.target === e.currentTarget) {
            $dialog.addClass("close");
            sessionStorage.setItem('dialogState', true);
            $(this).get(0).close();
            $("body").removeClass("freeze");
        }
    });

    if (!dialogState && $dialog.length > 0) {
        $dialog.get(0).showModal();
        $("body").addClass("freeze");
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * flipbox
    // *
    // *
    $(".js-flipbox")
        .on("click", function () {
            $(this).toggleClass("active");
        })
        .on("keydown", function (e) {
            // Check if Enter (key code 13) is pressed
            if (e.which === 13 || e.keyCode === 13) {
                e.preventDefault(); // Prevent default behavior (e.g., form submission)
                $(this).toggleClass("active");
            }
        });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * press escape
    // *
    // *
    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            $(".js-navbutton").removeClass("active");
            $(".js-navmobile").removeClass("active")
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * increase/decrease shop
    // *
    // *
    $(document).on('click', '[data-action="decrease"]', function () {
        const $input = $(this).siblings('.js-quantity-input');
        const currentValue = parseInt($input.val(), 10);
        if (currentValue > 0) {
            $input.val(currentValue - 1).trigger('change');
        }
    });

    $(document).on('click', '[data-action="increase"]', function () {
        const $input = $(this).siblings('.js-quantity-input');
        const currentValue = parseInt($input.val(), 10);
        $input.val(currentValue + 1).trigger('change');
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * hide deliverAdress
    // *
    // *
    $('.js-checkbox-hide').on('change', function () {
        if ($(this).is(':checked')) {
            $('.js-hide-formfields').hide();
            $('.js-hide-formfields input').prop('required', false);
        } else {
            $('.js-hide-formfields').show();
            $('.js-hide-formfields input').prop('required', true);
        }
    });

    if ($('.js-checkbox-hide').is(':checked')) {
        $('.js-hide-formfields').hide();
        $('.js-hide-formfields input').prop('required', false);
    };


    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * fly to cart
    // *
    // *
    function flyToElement(flyer, flyingTo, flySrc) {
        var divider = 3;
        var flyerClone = $(flyer).clone();
        $(flyerClone).css({ position: 'absolute', top: $(flySrc).offset().top + "px", left: $(flySrc).offset().left + "px", opacity: 1, 'z-index': 1000 }).addClass("clone");
        $('body').append($(flyerClone));
        var gotoX = $(flyingTo).offset().left + ($(flyingTo).width() / 2) - ($(flyer).width() / divider) / 2;
        var gotoY = $(flyingTo).offset().top + ($(flyingTo).height() / 2) - ($(flyer).height() / divider) / 2;

        $(flyerClone).animate({
            opacity: 0.1,
            left: gotoX,
            top: gotoY,
            width: $(flyer).width() / divider,
            height: $(flyer).height() / divider,
        }, 500,
            function () {
                $(flyingTo).fadeOut('fast', function () {
                    $(flyingTo).fadeIn('fast', function () {
                        $(flyerClone).fadeOut('fast', function () {
                            $(flyerClone).remove();
                        });
                    });
                });
            });
    }

    $('.js-flytocart-button').on('click', function () {
        var itemImg = $(this).parents(".js-flytocart-parent").find(".js-flytocart").eq(0);
        var quantity = $(this).parents(".js-flytocart-button-wrapper").find(".js-flytocart-quantity").val();
        var $this = $(this)
        for (var i = 0; i < quantity; i++) {
            setTimeout(function (index) {
                return function () {
                    flyToElement($(itemImg), $('.js-header-cart'), $this);
                };
            }(i), 200 * i); // 200 ms delay between each call
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * addToCart
    // *
    // *
    $(".js-addtocart").click(function () {
        var productQuantity = $(this).parents(".js-cart-wrapper").find(".js-cart-quantity").val();

        var $product = $(this).parents(".js-product");
        var productID = $product.data("product")
        var productDescription = $product.data("description");
        var productPrice = $product.data("price");
        var productImage = $product.data("image");
        var productVariant = '';

        var selectedVariant = $product.find('.js-variants .js-variant-input:checked');
        if (selectedVariant.length) {
            productVariant = selectedVariant.next('.js-variant-value').text();
        }

        // Prepare the data object for the AJAX request
        var ajaxData = {
            product: productID,
            quantity: productQuantity,
            description: productDescription,
            image: productImage,
            price: productPrice
        };

        // Only add the variant to the data if it is not empty
        if (productVariant) {
            ajaxData.variant = productVariant;
        }

        console.log(ajaxData)

        $.ajax({
            url: "/assets/components/site/connector.php?action=addtocart",
            type: 'GET',
            data: ajaxData
        }).done(function (data) {
            try {
                if (data.status === 'success') {
                    $(".js-cart-total").html(data.data.total_quantity);
                    $(".js-cart-badge").show()
                    $(".js-cart-link").attr('href', data.data.url);
                } else {
                    console.error('Error:', data.message || 'Unknown error');
                }
            } catch (e) {
                console.error('Failed to parse response:', e);
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error('AJAX request failed:', textStatus, errorThrown);
        });
    });
});

// hide add cart quantity flag if empty
var cartQuantity = $(".js-cart-total").html();
if (cartQuantity <= 0) (
    $(".js-cart-badge").hide()
);



// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 400) {
        $(".js-header-fixed").addClass("sticky");
    } else {
        $(".js-header-fixed").removeClass("sticky");
    }
});


$(window).on("resize", function () {
    if (window.innerWidth >= 1200) {
        $(".js-navmobile").removeClass("active");
        $(".js-navbutton").removeClass("active");
    }
});

// Run on page load
window.addEventListener('load', function() {
  handleAnchorScroll();
});

// Also run after a delay to catch late-loading content
setTimeout(handleAnchorScroll, 500);
var scrollMargin = window.innerWidth > 768 ? 150 : 110;

function handleAnchorScroll() {
  if (window.location.hash) {
    const element = document.getElementById(window.location.hash.substring(1));
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: elementPosition - scrollMargin,
        behavior: 'smooth'
      });
    }
  }
}